import { ManaulShopperPage } from "./../manaul-shopper/manaul-shopper";
import { SelectLanguagePage } from "./../select-language/select-language";
import { ShopperVotePage } from "./../shopper-vote/shopper-vote";
import { ShopperMissionSocialPage } from "./../shopper-mission-social/shopper-mission-social";
import { ShopperBuyProductPlazalistPage } from "./../shopper-buy-product-plazalist/shopper-buy-product-plazalist";
import { ShopperShoppingBagPage } from "./../shopper-shopping-bag/shopper-shopping-bag";
import { ShopperResultPage } from "./../shopper-result/shopper-result";
import { ShopperSocialGroupPage } from "./../shopper-social-group/shopper-social-group";
import { ShopperRequrementPage } from "./../shopper-requrement/shopper-requrement";
import { ShopperMissionPage } from "./../shopper-mission/shopper-mission";
import { ShopperOverviewPage } from "./../shopper-overview/shopper-overview";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";
import { LoginPage } from "./../login/login";

@IonicPage()
@Component({
  selector: "page-shopper-home",
  templateUrl: "shopper-home.html",
})
export class ShopperHomePage {
  shopper_no: any;
  step: any;
  sub_step: any;
  round = 0;
  plazaList: any;
  stat_hp: any;
  shopper_name = "";
  title = "HOME PAGE";
  isVote = 0;
  theme = 2;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("info").then((info) => {
      this.shopper_no = info.team.shopper_id;
      this.shopper_name = info.name;
    });

    this.storage.get("isVote").then((vote) => {
      if (vote) {
        this.isVote = vote;
      }
    });

    this.storage.get("token").then((token) => {
      // setInterval(() => {
      var link = this.services.URLCheckStep;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.step = data.step;
            this.round = data.round;
            this.sub_step = data.sub_step;

            if (this.round > 1) {
              this.title = "Round " + this.round;
            }

            this.storage.get("currentStep").then((oldStep) => {
              if (!oldStep) {
                this.storage.set("currentStep", data.step);
              } else if (oldStep != data.step) {
                this.storage.set("currentStep", data.step);
                if (data.step == 1 && data.round == 1) {
                  this.storage.remove("stepGame");
                  this.storage.remove("roundGame");
                  this.storage.remove("language");
                  this.storage.remove("quizRound");
                  this.navCtrl.setRoot(SelectLanguagePage);
                }
              }
            });

            this.storage.get("roundGame").then((oldRound) => {
              if (!oldRound) {
                this.storage.set("roundGame", data.round);
              } else if (oldRound != data.round) {
                this.storage.set("roundGame", data.round);
              }
            });

            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);

            if (
              response.status == 403 &&
              response.message == "You are not allowed to perform this action."
            ) {
              if (this.storage.clear()) {
                this.navCtrl.setRoot(LoginPage);
              }
            }

            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      // }, 3000);
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      // setInterval(() => {
      var link = this.services.URLCheckStep;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.step = data.step;
            this.round = data.round;

            if (this.round > 1) {
              this.title = "Round " + this.round;
            }

            this.storage.get("currentStep").then((oldStep) => {
              if (!oldStep) {
                this.storage.set("currentStep", data.step);
              } else if (oldStep != data.step) {
                this.storage.set("currentStep", data.step);
                if (data.step == 1 && data.round == 1) {
                  this.storage.remove("stepGame");
                  this.storage.remove("roundGame");
                  this.storage.remove("language");
                  this.storage.remove("quizRound");
                  this.navCtrl.setRoot(SelectLanguagePage);
                }
              }
            });

            this.storage.get("roundGame").then((oldRound) => {
              if (!oldRound) {
                this.storage.set("roundGame", data.round);
              } else if (oldRound != data.round) {
                this.storage.set("roundGame", data.round);
              }
            });

            refresher.complete();
          },
          (error) => {
            var response = JSON.parse(error._body);
            refresher.complete();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      // }, 3000);
    });
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  overviewPage() {
    this.navCtrl.push(ShopperOverviewPage);
  }

  missionPage() {
    this.navCtrl.push(ShopperMissionPage);
  }

  shopperReqPage() {
    this.navCtrl.push(ShopperRequrementPage, {});
  }

  socialGroup() {
    this.navCtrl.push(ShopperSocialGroupPage);
  }

  shoppingProduct() {
    this.navCtrl.push(ShopperBuyProductPlazalistPage);
  }

  shoppingSocial() {
    this.navCtrl.push(ShopperMissionSocialPage);
  }

  shoppingBag() {
    this.navCtrl.push(ShopperShoppingBagPage);
  }

  vote() {
    this.navCtrl.push(ShopperVotePage);
  }

  result() {
    if (this.step == 7) {
      this.storage.get("token").then((token) => {
        var link = this.services.URLShopperStatHappiness;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.stat_hp = [
                ["SHOP", parseInt(data.shop)],
                ["SOCIAL", parseInt(data.social)],
                ["THEME", parseInt(data.theme)],
              ];
              this.navCtrl.push(ShopperResultPage, { stat_hp: this.stat_hp });
            },
            (error) => {
              var response = JSON.parse(error._body);

              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    }
  }

  manual() {
    this.navCtrl.push(ManaulShopperPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-home/shopper-home.ts